var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M.3 0h53.4v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.3 20h53.4v20H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M35 20 .3 40V0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcd116",
    d: "m2.6 3.5 1.1 1 1.4-.7-.6 1.5 1.2 1H4l-.7 1.4L3.1 6H1.5l1.4-.8zm27 14.4v1.6l1.5.5-1.5.5v1.6l-1-1.3-1.5.5.9-1.3-1-1.3 1.6.5zM3.3 32.3l.7 1.5 1.6-.2-1.2 1.1.6 1.5-1.3-.8-1.2 1 .3-1.5-1.4-.8 1.6-.2zM13 11.6l-.5.5.3 4h-.3l-.4-3.6-.5.4.7 3.2-1.5.6L9 14h-.6l2.2 2.8-.2.2-2.6-3H7v.8l3 2.6-.2.2-2.9-2.2v.6l2.7 1.8-.6 1.4-3.1-.6-.5.4 3.6.5v.2l-4-.2-.5.5.6.5 3.9-.2v.2l-3.6.5.4.4 3.2-.6.6 1.4L7 24v.6l2.9-2.2.2.2-3 2.6v.7h.7l2.6-3 .2.3L8.3 26H9l1.8-2.7 1.5.6-.7 3.2.5.4.4-3.6h.3l-.3 4 .5.5.6-.5-.3-4h.3l.4 3.6.5-.4-.7-3.2 1.5-.6L17 26h.6l-2.2-2.8.2-.2 2.6 3h.7v-.8l-3-2.6.2-.2 2.9 2.2V24l-2.7-1.8.6-1.4 3.1.6.5-.4-3.6-.5v-.2l4 .2.5-.5-.6-.5-3.9.2v-.2l3.6-.5-.4-.4-3.2.6-.6-1.4L19 16v-.6l-3 2.2-.2-.2 3-2.6V14h-.7l-2.6 3-.2-.3 2.2-2.8H17l-1.8 2.7-1.5-.6.7-3.2-.5-.4-.4 3.6h-.3l.3-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPh);
export default __webpack_public_path__ + "static/media/ph.dbad8b5921329026aa67a29dafcd9c02.svg";
export { ForwardRef as ReactComponent };